var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5 16.5C9.22386 16.5 9 16.7239 9 17C9 17.2761 9.22386 17.5 9.5 17.5H14.5C14.7761 17.5 15 17.2761 15 17C15 16.7239 14.7761 16.5 14.5 16.5H9.5Z",
    fill: "#121212",
    stroke: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1688 2.57518C12.8972 1.5713 11.1028 1.5713 9.83124 2.57518L3.33124 7.70676C2.49051 8.3705 2 9.38268 2 10.4538V18.5C2 20.433 3.567 22 5.5 22H18.5C20.433 22 22 20.433 22 18.5V10.4538C22 9.38268 21.5095 8.3705 20.6688 7.70676L14.1688 2.57518ZM10.4509 3.36006C11.3592 2.643 12.6408 2.643 13.5491 3.36006L20.0491 8.49164C20.6496 8.96574 21 9.68873 21 10.4538V18.5C21 19.8807 19.8807 21 18.5 21H5.5C4.11929 21 3 19.8807 3 18.5V10.4538C3 9.68873 3.35036 8.96574 3.95089 8.49164L10.4509 3.36006Z",
    fill: "#121212",
    stroke: "#121212"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHome);
export default __webpack_public_path__ + "static/media/icon_home.5235c5973537e0c95e60aae27cacb878.svg";
export { ForwardRef as ReactComponent };